import { Component, OnDestroy, OnInit } from '@angular/core';
import { Asset } from '../../../models/asset.class';
import { AssetsManagerService } from '../../../../../data/assets/assets-manager.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HardwareConfiguration, SensorType } from 'src/app/shared/models/vehicle.model';
import { ConfigurationModel, FeatureFlagEnum } from 'src/app/shared/models/configuration.model';
import { ShiftsManagerService } from '../../../../../data/shifts/shifts-manager.service';
import { ConfigurationService } from '../../../../../configuration/configuration.service';
import {combineLatest, Observable, Subscription} from 'rxjs';
import { MapControlService } from '../../../../../shared/components/map-viewer/services/map-control.service';
import { ShiftsService } from '../../../../../data/shifts/shifts.service';
import moment from 'moment';
import { DrawerContent, DrawerType } from 'src/app/layouts/right-drawer/right-drawer.component';
import { LiveMapDataService } from '../../../services/live-map-data.service';
import { ShiftState } from 'src/app/shared/models/shift.model';
import { RouteAssignment, RouteAssignmentStatus } from '../../../../../shared/models/route-assignment';
import { ArcgisApiService } from '../../../../../data/address-search/arcgis-api.service';
import { LocationSocketService } from '../../../../../data/websocket/location-socket.service';
import { MovementAndLocationDetail } from './MovementAndLocationDetail';
import { RouteAssignmentService } from '../../../../../data/routes/route-assignment.service';
import { RouteAssignmentManagerService } from '../../../../../data/routes/route-assignment-manager.service';
import { SecurityService } from '../../../../../security/security.service';
import { InsightsRoute } from '../../../../insights/insights.routes';
import { ToastService } from '../../../../../shared/services/toast.service';
import { MainRoute, RootRoute, SettingsRoute } from '../../../../../shared/models/angular-routing';
import { ShiftDevices } from '../../../../../data/websocket/model/message.event';
import { RightPanel } from '../../right-panel/right-panel.class';
import { LocationApiService } from '../../../../../data/location-api/location-api.service';
import { MetricType } from '../../../../../shared/models/session-metric.model';
import { ImageService } from '../../../../../data/images/image.service';
import { ImageModel } from '../../../../../shared/models/image';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ImageViewerComponent } from '../../../../../shared/components/image-viewer/image-viewer.component';
import { RouteAssignmentQueueComponent } from '../route-assignment-queue/route-assignment-queue.component';
import {map} from 'rxjs/operators';
import { DurationPipe } from '../../../../../shared/formatting/duration.pipe';
import { DistancePipe } from '../../../../../shared/formatting/distance.pipe';
import { PlowStatusPipe } from '../../../../../shared/formatting/plow-status.pipe';
import { RateUnitPipe } from '../../../../../shared/formatting/rate-unit.pipe';
import { SpreaderStatusPipe } from '../../../../../shared/formatting/spreader-status.pipe';
import { SpreaderMassPipe } from '../../../../../shared/formatting/spreader-mass.pipe';
import { SpreaderLiquidPipe } from '../../../../../shared/formatting/spreader-liquid.pipe';
import { MowerStatusPipe } from '../../../../../shared/formatting/mower-status.pipe';
import { SweeperStatusPipe } from '../../../../../shared/formatting/sweeper-status.pipe';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.scss'],
  imports: [
    MatTooltip,
    NgClass,
    MatIconButton,
    RouterLink,
    MatIcon,
    MatButton,
    MatProgressSpinner,
    ImageViewerComponent,
    DatePipe,
    RouteAssignmentQueueComponent,
    AsyncPipe,
    DurationPipe,
    DistancePipe,
    PlowStatusPipe,
    RateUnitPipe,
    SpreaderStatusPipe,
    SpreaderMassPipe,
    SpreaderLiquidPipe,
    MowerStatusPipe,
    SweeperStatusPipe,
  ],
})
export class AssetComponent implements OnInit, OnDestroy {
  hasVehicleMgmtAccess$: Observable<boolean>;
  configuration: ConfigurationModel;
  assets: Asset[];
  asset: Asset;
  assetMovementAndLocationDescription = '';
  activeDrawer: DrawerContent;
  completeRouteAssignments: RouteAssignment[];
  avgDistancePerAssignment: number;
  avgTimePerAssignment: number;
  lastShiftImageModel: ImageModel;
  imageLoading = true;
  expanded = true;

  ShiftState = ShiftState;
  ShiftDevices = ShiftDevices;
  HardwareConfiguration = HardwareConfiguration;
  SensorType = SensorType;
  FeatureFlagEnum = FeatureFlagEnum;
  RouteAssignmentStatus = RouteAssignmentStatus;
  InsightsRoute = InsightsRoute;
  MainRoute = MainRoute;
  RootRoute = RootRoute;
  SettingsRoute = SettingsRoute;
  DrawerType = DrawerType;

  shiftDurationIntervalId: NodeJS.Timeout;
  distanceDrivenIntervalId: NodeJS.Timeout;

  private readonly openSubscriptions = Array<Subscription>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private securityService: SecurityService,
    private assetsManager: AssetsManagerService,
    private shiftManager: ShiftsManagerService,
    private shiftService: ShiftsService,
    private imageService: ImageService,
    private configurationService: ConfigurationService,
    private liveMapDataService: LiveMapDataService,
    private mapControlService: MapControlService,
    private locationSocketService: LocationSocketService,
    private arcGisApiService: ArcgisApiService,
    private routeAssignmentService: RouteAssignmentService,
    private routeAssignmentManager: RouteAssignmentManagerService,
    private locationApi: LocationApiService,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.hasVehicleMgmtAccess$ = this.securityService.hasPermission(SettingsRoute.MANAGE_VEHICLES);

    // combined observable
    const params$ = this.activatedRoute.params.pipe(map(p => +p['id']));
    const assets$ = this.assetsManager.assets$;

    const combinedSubscription = combineLatest([assets$, params$]).subscribe(([assets, assetId]) => {
      this.assets = assets;
      if (!!assetId && !!assets && assets.length > 0) {
        const foundAsset = assets.find(a => a.id === assetId);
        if (foundAsset) {
          if (this.asset?.id !== foundAsset.id) {
            this.changeAsset(assetId);
          } else {
            this.updateMovementAndLocationDescription();
            this.updateLastShiftImage();
          }
        }
      }
    });
    this.openSubscriptions.push(combinedSubscription);

    this.activatedRoute.queryParams.subscribe(params => {
      this.activeDrawer = params.drawer;
    });

    const configSubscription = this.configurationService.sharedConfigurationModel.subscribe(model => {
      if (model) {
        this.configuration = model;
      }
    });
    this.openSubscriptions.push(configSubscription);

    const assignmentsSubscription = this.routeAssignmentManager.recentRouteAssignments$.subscribe(assignmentsUpdate => {
      if (assignmentsUpdate.updated.length > 0) {
        assignmentsUpdate.updated.forEach(assignment => {
          // if updated assignment belongs to this vehicle
          if (
            assignment.vehicleId === this.asset?.id &&
            !!assignment.completed &&
            !!this.completeRouteAssignments &&
            !this.completeRouteAssignments.find(a => a.id === assignment.id) &&
            this.asset.shiftId === assignment.shiftId
          ) {
            this.completeRouteAssignments.push(assignment);
            this.updateAssignmentMetrics();
          }
        });
      }
    });
    this.openSubscriptions.push(assignmentsSubscription);
  }

  ngOnDestroy() {
    this.openSubscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this.assetsManager.filterByVehicleIds(null);
    if (!!this.shiftDurationIntervalId) {
      clearInterval(this.shiftDurationIntervalId);
    }
    if (!!this.distanceDrivenIntervalId) {
      clearInterval(this.distanceDrivenIntervalId);
    }
  }

  changeAsset(assetId: number) {
    const found = this.assets.find(asset => asset.id === assetId);
    if (!found) {
      return; // Wait for the next emission
    }
    this.asset = found;
    this.assetsManager.filterByVehicleIds([assetId]);

    if (this.asset.shiftStatus !== ShiftState.ENDED) {
      this.mapControlService.zoomToShiftExtent(this.asset.shiftId);

      // update duration every second
      if (!!this.shiftDurationIntervalId) {
        clearInterval(this.shiftDurationIntervalId);
      }
      this.shiftDurationIntervalId = setInterval(() => {
        this.asset.shiftDuration = moment().diff(moment(this.asset.shiftStartTime), 'seconds');
      }, 1000);

      // update distance driven every 30s
      if (!!this.distanceDrivenIntervalId) {
        clearInterval(this.distanceDrivenIntervalId);
      }
      this.distanceDrivenIntervalId = setInterval(() => {
        this.updateDistanceDriven();
      }, 30 * 1000);

      // update distance driven whenever the geometry cache is updated
      this.updateDistanceDriven();
      this.updateDigitalSpreaderStatus();
      this.updateMovementAndLocationDescription();
      this.loadCompletedAssignmentsMetrics();
      this.lastShiftImageModel = null;
      this.updateLastShiftImage();
    } else {
      this.mapControlService.zoomToCoordinates(this.asset.location);
    }
  }

  updateMovementAndLocationDescription() {
    if (this.asset == null || this.asset.location == null) {
      this.assetMovementAndLocationDescription = new MovementAndLocationDetail(
        this.asset?.speed,
        this.asset?.currentHeading,
        null
      ).toDescription();
    } else {
      // console.log(`rGeo id = '${this.asset.id}', [lat, lng] = [${this.asset.location.lat}, ${this.asset.location.lng}]`);
      this.arcGisApiService.findAddressOfLocation(this.asset.location).then(reverseGeocodeInfo => {
        this.assetMovementAndLocationDescription = new MovementAndLocationDetail(
          this.asset.speed,
          this.asset.currentHeading,
          reverseGeocodeInfo
        ).toDescription();
      });
    }
  }

  forceEndShift(shiftId: number) {
    this.shiftManager.forceEndShiftForVehicle(shiftId);
  }

  hasFeatureFlag(featureFlag: string): boolean {
    return this.configuration.featureFlags.find(value => value.isEnabled && value.name === featureFlag) !== undefined;
  }

  getRightPanelQueryParams(drawerType: DrawerType) {
    const queryParams = { drawer: drawerType.content };
    queryParams[RightPanel.TRIGGER_VEHICLE_ACTION_PARAM_NAME] = true;
    return queryParams;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  close() {
    this.router.navigate([`/${RootRoute.MAIN}`], {
      queryParamsHandling: 'merge',
    });
  }

  private updateDistanceDriven() {
    const assetId = this.asset?.id;
    if (!!this.asset && this.asset.shiftStatus !== ShiftState.ENDED) {
      this.shiftService
        .getShiftDistanceDriven(this.asset.shiftId)
        .then(response => {
          if (this.asset.id === assetId) {
            this.asset.distanceDriven = response.data.distance;
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }

  private updateDigitalSpreaderStatus() {
    this.asset.digitalGranularStatus = null;
    this.asset.digitalLiquidStatus = null;
    const hwConfig = this.asset.vehicleHardwareConfiguration;
    if (!!hwConfig && !!hwConfig.digitalSpreader) {
      if (hwConfig.digitalSpreader.settings.readGranular) {
        this.locationApi
          .closestSessionMetricEvent(this.asset.shiftId, this.asset.id, MetricType.GRANULAR_RATE)
          .then(metric => {
            this.asset.digitalGranularStatus = {
              controllerCurrentRate: metric?.data?.metricValue ?? 0,
              controllerMaxRate: hwConfig.digitalSpreader.settings.granularMaxRate,
            };
          })
          .catch(error => {
            console.error(error);
            this.toast.short('Failed to load Digital Spreader granular values!');
          });
      }

      if (hwConfig.digitalSpreader.settings.readLiquid) {
        this.locationApi
          .closestSessionMetricEvent(this.asset.shiftId, this.asset.id, MetricType.LIQUID_RATE)
          .then(metric => {
            this.asset.digitalLiquidStatus = {
              controllerCurrentRate: metric?.data?.metricValue ?? 0,
              controllerMaxRate: hwConfig.digitalSpreader.settings.granularMaxRate,
            };
          })
          .catch(error => {
            console.error(error);
            this.toast.short('Failed to load Digital Spreader liquid values!');
          });
      }
    }
  }

  private loadCompletedAssignmentsMetrics() {
    if (!!this.asset && this.asset.shiftStatus !== ShiftState.ENDED) {
      this.routeAssignmentService
        .getRouteAssignments(null, this.asset.id, this.asset.shiftId, null, null, true, false, true)
        .then(response => {
          this.completeRouteAssignments = response.data.filter(assignment => !!assignment.completed);
          this.updateAssignmentMetrics();
        });
    }
  }

  private updateAssignmentMetrics() {
    if (!!this.completeRouteAssignments) {
      let totalDistance = 0;
      let totalTime = 0;
      this.avgDistancePerAssignment = 0;
      this.avgTimePerAssignment = 0;
      for (const assignment of this.completeRouteAssignments) {
        totalDistance += assignment.distanceDriven || 0;
        totalTime += assignment.timeDriven || 0;
      }
      const assignmentCount = this.completeRouteAssignments.length;
      if (assignmentCount > 0) {
        this.avgDistancePerAssignment = totalDistance / assignmentCount;
        this.avgTimePerAssignment = totalTime / assignmentCount;
      }
    }
  }

  private updateLastShiftImage() {
    if (
      !!this.asset &&
      (!this.configuration || this.hasFeatureFlag(FeatureFlagEnum.DashCam)) &&
      !!this.asset.cameraConfiguration &&
      this.asset.shiftStatus !== ShiftState.ENDED
    ) {
      this.imageLoading = true;
      this.imageService
        .getLastShiftImage(this.asset.shiftId)
        .then(imageModel => {
          this.imageLoading = false;
          if (!!imageModel) {
            this.lastShiftImageModel = imageModel;
          }
        })
        .catch(error => {
          this.imageLoading = false;
          this.lastShiftImageModel = null;
        });
    }
  }
}
